import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  templateUrl: './errorModal.component.pug',
})
export class ErrorModalComponent {
  @Input() report: string

  constructor (
    protected modalInstance: NgbActiveModal,
  ) { }

  close () {
    this.modalInstance.dismiss()
  }
}
